var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.5 91C443.5 78.5736 433.428 68.5 421 68.5H352.733C332.74 68.5 322.678 92.6268 336.746 106.832L343.575 113.729L219.203 234.361C210.187 243.106 210.077 257.54 218.959 266.422L240.171 287.634C248.863 296.326 262.922 296.433 271.746 287.875L397.254 166.14L406.206 173.952C420.76 186.654 443.5 176.317 443.5 157V91ZM370.701 98.5H413.5V140.5C404.191 132.376 390.823 130.585 381.321 139.801L256.161 261.198L245.557 250.593L369.902 129.987C378.723 121.432 379.024 107.425 370.701 98.5Z",
    fill: "#5A83FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.25 351.625C252.25 402.366 211.116 443.5 160.375 443.5C109.634 443.5 68.5 402.366 68.5 351.625C68.5 300.884 109.634 259.75 160.375 259.75C211.116 259.75 252.25 300.884 252.25 351.625ZM222.25 351.625C222.25 385.798 194.548 413.5 160.375 413.5C126.202 413.5 98.5 385.798 98.5 351.625C98.5 317.452 126.202 289.75 160.375 289.75C194.548 289.75 222.25 317.452 222.25 351.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasses);
export default __webpack_public_path__ + "static/media/passes.bb920a1023bc642b4b0b470a96297201.svg";
export { ForwardRef as ReactComponent };